import { createGlobalStyle } from "styled-components";
import { Roboto } from "./Fonts";

const appContainer = `font-family: "Roboto", sans-serif;
margin: 0;
padding: 0;
outline: 0;
box-sizing: border-box;`;

const instMoviContext =
  process.env.REACT_APP_ENVIRONMENT !== "productionMovidesk";

export default createGlobalStyle`

  ${instMoviContext && Roboto}
 
  * {
    ${instMoviContext && appContainer}
  }

  div#root {
    background: #fafafa;
    color: #5f5f5f;
    
  }  
`;
